import React from "react";


export const SidebarData=[
    {  
        title:"Home",
        path:"/homepage",
        cName:"nav-text",
    },
    {    
        title:"Shop",
        path:"/shop",
     
        cName:"nav-text",
    },
    {  
        title:"Men",
        path:"/men",
       
        cName:"nav-text",
    },
    {
        title:"Women",
        path:"/women",
 
        cName:"nav-text",
    },
    {  
        title:"About",
        path:"/about",
 
        cName:"nav-text",
    },

]